/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Step_4_DescInputs */

const es_home_intro_step_4_desc = /** @type {(inputs: Home_Intro_Step_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados instantáneos con contexto completo, citas exactas y enlaces directos.`)
};

const en_home_intro_step_4_desc = /** @type {(inputs: Home_Intro_Step_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant results with full context, exact citations, and direct links.`)
};

/**
* | output |
* | --- |
* | "Instant results with full context, exact citations, and direct links." |
*
* @param {Home_Intro_Step_4_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_step_4_desc = /** @type {((inputs?: Home_Intro_Step_4_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Step_4_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_step_4_desc(inputs)
	return en_home_intro_step_4_desc(inputs)
});
export { home_intro_step_4_desc as "home.intro.step_4_desc" }